import { elevation, themeColors } from "@dana/MobiusOverrides/styles/colors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { orderUploadStyles } from "@insite/content-library/Components/OrderUpload";
import { css } from "styled-components";

orderUploadStyles.downloadTemplateButton = mergeToNew(orderUploadStyles.downloadTemplateButton, {
    variant: "secondary",
});

orderUploadStyles.includeFirstRowCheckbox = mergeToNew(orderUploadStyles.includeFirstRowCheckbox, {
    mergeCss: true,
    css: css`
        display: flex;
        align-items: center;
    `,
});

orderUploadStyles.fileUploader = mergeToNew(orderUploadStyles.fileUploader, {
    mergeCss: true,
    buttonProps: {
        variant: "secondary",
        mergeCss: true,
        css: css`
            line-height: normal;
        `,
    },
    cssOverrides: {
        formField: css`
            .mobiusFileUpload {
                height: 100%;
                display: flex;
                align-items: center;

                &:focus-within {
                    box-shadow: ${elevation.hover};
                    border: 1px solid ${themeColors.primary.danaBlue};
                    height: 100%;

                    [class*="FormFieldClickable"] {
                        right: 0;
                    }
                }

                input:not(.react-datetime-picker__inputGroup__input):focus {
                    height: 100%;
                }
            }
        `,
        formInputWrapper: css`
            &,
            .mobiusFileUpload {
                height: 100%;
            }
        `,
        appearanceTransition: css`
            position: relative;
            width: 96%;

            [class*="FormFieldClickable"] {
                top: 50%;
                transform: translateY(-50%);
            }
        `,
    },
});

orderUploadStyles.uploadFileButton = mergeToNew(orderUploadStyles.uploadFileButton, {
    variant: "primary",
    mergeCss: true,
    css: css`
        line-height: normal;
    `,
});

orderUploadStyles.cancelUploadButton = mergeToNew(orderUploadStyles.cancelUploadButton, {
    variant: "secondary",
});
